import { render, staticRenderFns } from "./giro.vue?vue&type=template&id=bdbc1b90&scoped=true"
import script from "./giro.vue?vue&type=script&lang=js"
export * from "./giro.vue?vue&type=script&lang=js"
import style0 from "./giro.vue?vue&type=style&index=0&id=bdbc1b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbc1b90",
  null
  
)

export default component.exports